import React from 'react';

const ReferralIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10 2.5C8.61929 2.5 7.5 3.61929 7.5 5C7.5 5.54313 7.6729 6.04551 7.96685 6.45574L5.75 8.67259C5.33854 8.3736 4.8339 8.19444 4.28571 8.19444C2.90501 8.19444 1.78571 9.31373 1.78571 10.6944C1.78571 12.0751 2.90501 13.1944 4.28571 13.1944C4.8339 13.1944 5.33854 13.0153 5.75 12.7163L7.96685 14.9331C7.6729 15.3434 7.5 15.8457 7.5 16.3889C7.5 17.7696 8.61929 18.8889 10 18.8889C11.3807 18.8889 12.5 17.7696 12.5 16.3889C12.5 15.8457 12.3271 15.3434 12.0332 14.9331L14.25 12.7163C14.6615 13.0153 15.1661 13.1944 15.7143 13.1944C17.095 13.1944 18.2143 12.0751 18.2143 10.6944C18.2143 9.31373 17.095 8.19444 15.7143 8.19444C15.1661 8.19444 14.6615 8.3736 14.25 8.67259L12.0332 6.45574C12.3271 6.04551 12.5 5.54313 12.5 5C12.5 3.61929 11.3807 2.5 10 2.5Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default ReferralIcon;
